import React from 'react';
import { H2, P, OL, LI, Callout, FeatureLink } from './_shared';

export default {
  slug: 'team-workspace',
  title: 'Teams & shared workspaces',
  category: 'team',
  summary: 'Inviting agents, switching between personal and team workspaces, what gets shared vs stays private.',
  searchTerms: ['team', 'workspace', 'invite', 'shared', 'brokerage', 'agent'],
  related: ['broker-dashboard', 'branding'],
  Body: () => (
    <>
      <P>
        Team plans (Team Starter, Team Pro, Agency, Enterprise) add a shared
        workspace alongside your personal one. Clients, deals, and folders
        in the team workspace are visible to everyone on the team; your
        personal workspace stays private.
      </P>

      <H2>Inviting an agent</H2>
      <OL>
        <LI>Open <FeatureLink to="/team">Team</FeatureLink> as the team owner.</LI>
        <LI>Click "Invite Agent," enter their name and email.</LI>
        <LI>They get an email with an invitation link. Existing RealtyFlows users join with one click; new users are prompted to sign up.</LI>
        <LI>Once they accept, they show up in the team list with a workspace switcher at the top of the app.</LI>
      </OL>

      <H2>What's shared</H2>
      <P>
        Anything created in the team workspace: clients, deals, folders,
        templates, branding, compliance checklists. Activity feeds attribute
        each action to the agent who took it.
      </P>

      <H2>What stays private</H2>
      <P>
        Everything in an agent's personal workspace. Switching between
        workspaces is one click and the URL reflects which one you're in.
      </P>

      <Callout kind="warn">
        Deactivating an agent (Team → Agent → Deactivate) revokes their
        access but preserves all their team-workspace data and activity
        history. Records can't be retroactively reassigned — they keep the
        original agent's name in the audit trail. That's required for
        compliance.
      </Callout>
    </>
  ),
};
